export const getLevelValue = (level: number) => {
  if (level === 1) {
    return 50;
  } else if (level === 2) {
    return 150;
  } else if (level === 3) {
    return 300;
  } else if (level === 4) {
    return 600;
  } else {
    return 1200;
  }
};
